import React from "react"
import Paper from "@material-ui/core/Paper";
import InputLabel from '@material-ui/core/InputLabel';
import HamaTable from "../../common/component/HamaTable";
import {User, UserState} from "../../store/user/types";
import {AccountState, OverviewAccounts} from "../../store/account/types";
import {connect} from "react-redux";
import {AppState} from "../../store";
import {withTranslation, WithTranslation} from "react-i18next";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {compose} from "redux";
import axios from "axios";
import http from "http";
import AlertDialog from "../../common/component/AlertDialog";
import EditAccountDialog from "../admin/EditAccountDialog"

interface IProps {
    user: UserState;
    accounts: AccountState;
    t: any;
}

interface IAdminState {
    accounts: Array<OverviewAccounts>;
    user: User;
    showInfoDialog: boolean,
    showCreateDialog: boolean,
    showDeleteDialog: boolean,
    showDialogMessage: string,
    loadOnClose: boolean,
    selectedAccounts: Array<OverviewAccounts>,
    showEditAccountDialog: boolean
}

class Admin extends React.Component <IProps, IAdminState> {

    state = {
        accounts: new Array<OverviewAccounts>(),
        user: this.props.user.user ? this.props.user.user : {login: ''},
        showInfoDialog: false,
        showCreateDialog: false,
        showDeleteDialog: false,
        showDialogMessage: '',
        loadOnClose: false,
        selectedAccounts: new Array<OverviewAccounts>(),
        showEditAccountDialog: false
    }

    create() {
        const {t} = this.props;
        this.setState({
            showCreateDialog: true,
            showDialogMessage: t('Accounts.create')
        });
        this.createAccounts();
    };

    createPassword(selected: Array<OverviewAccounts>) {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts/admin/password/';
        const httpAgent = new http.Agent({keepAlive: true});
        const instance = axios.create({
            httpAgent,
        });
        const {t} = this.props;
        if (!(selected === null || selected === undefined)) {
            selected.forEach(x =>
                axios.get(url + x.login, {httpAgent})
                    .then(res => {
                        if (res.status == 200) {
                            console.log("res.status = " + res.status)
                            this.setState({
                                showInfoDialog: true,
                                showDialogMessage: t('Accounts.passwordAccount') + ' ' + x.login + ' ' + t('Accounts.generated') + '!'
                            });
                        } else {
                            console.log('Failed to create Accounts: server error: ' + res.status + "!");
                        }
                    })
                    .catch(err => {
                        console.log('Failed to create Accounts: server error');
                        console.log(err);
                    })
            );
        }
    }

    edit(selected: Array<OverviewAccounts>) {
        if (!(selected === null || selected === undefined)) {
            const selAccount = selected[0];
            const account = this.state.accounts.find(e => e.login === selAccount.login);
            if (!(account === null || account === undefined)) {
                if (account.enabled == null) {
                    account.enabled = true
                }
                selected[0] = account;
                this.setState({
                    showEditAccountDialog: true,
                    selectedAccounts: selected
                });
            }
        }
    }

    delete(selected: Array<OverviewAccounts>) {
        const {t} = this.props;
        if (!(selected === null || selected === undefined)) {
            this.setState({
                showDeleteDialog: true,
                showDialogMessage: t('Accounts.areYouSure'),
                selectedAccounts: selected
            });
        }
    }

    render() {
        const dataRows = this.state.accounts ? this.state.accounts.map(row => ({
            supplierId: row.supplierId,
            login: row.login,
            company: row.company,
            firstName: row.firstName,
            lastName: row.lastName,
            email: row.email
        })) : new Array<OverviewAccounts>();

        const {t} = this.props;
        if (this.props.user.isLoggedIn) {
            return (
                <Paper style={{padding: "10px", margin: "25px"}}>
                    <InputLabel> <strong>{t('Admin.title')}</strong> </InputLabel>
                    <InputLabel> {t('Admin.header')}</InputLabel>
                    <div>
                        <HamaTable selectable t={this.props.t} data={dataRows} title='Accounts'
                                   buttons={[{title: 'Admin.create', onClick: () => this.create()},
                                       {
                                           title: 'Admin.createPassword',
                                           selectionMulti: true,
                                           onClick: (selection: any) => this.createPassword(selection)
                                       },
                                       {
                                           title: 'Admin.edit',
                                           selectionMulti: false,
                                           onClick: (selection: any) => this.edit(selection)
                                       },
                                       {
                                           title: 'Admin.delete',
                                           selectionMulti: true,
                                           onClick: (selection: any) => this.delete(selection)
                                       }]}
                        />
                    </div>
                    <AlertDialog title={"Info"}
                                 message={t(this.state.showDialogMessage)}
                                 buttons={[{label: t('common.ok'), value: false}]}
                                 isOpen={this.state.showInfoDialog}
                                 onClose={() => this.onCloseDialog(this.state.loadOnClose)}/>
                    <AlertDialog title={t("Accounts.deleteAccount")}
                                 message={t(this.state.showDialogMessage)}
                                 buttons={[{label: t('common.yes'), value: true}, {
                                     label: t('common.no'),
                                     value: false
                                 }]}
                                 isOpen={this.state.showDeleteDialog}
                                 onClose={this.onConfirmDeleteDialog}/>
                    <AlertDialog title={t("Accounts.create")}
                                 message={''}
                                 buttons={[]}
                                 isOpen={this.state.showCreateDialog}/>
                    <EditAccountDialog open={this.state.showEditAccountDialog}
                                       //t={this.props.t}
                                       account={this.state.selectedAccounts}
                                       user={{login: ''}}
                                       closeDialog={this.onConfirmEditAccountDialog}/>
                </Paper>
            )
        }
    }

    componentWillMount() {
        this.loadAccounts();
    }

    componentDidMount(): void {
        document.title = this.props.t('Admin.doctitle')
    }

    onCloseDialog(loadOnClose: boolean) {
        this.setState({showCreateDialog: false});
        this.setState({showInfoDialog: false});
        loadOnClose ? this.loadAccounts() : null;
    }

    onConfirmDeleteDialog = (value: boolean) => {
        this.setState({showDeleteDialog: false});
        if (value === true) {
            this.deleteAccounts();
        }
    }

    onConfirmEditAccountDialog = (value: boolean) => {
        this.setState({showEditAccountDialog: false});
    }

    onConfirmCreateDialog = (value: boolean) => {
        this.createAccounts();
    }

    createAccounts() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts/admin/create';
        const httpAgent = new http.Agent({keepAlive: true});
        const instance = axios.create({
            httpAgent,
        });
        axios.get(url, {httpAgent})
            .then(res => {
                if (res.status == 200) {
                    if (res.data) {
                        this.setState({
                                showInfoDialog: true,
                                showDialogMessage: res.data.length + " " + this.props.t('Accounts.accountsCreated') + '!',
                                loadOnClose: true
                            },
                        );
                    } else {
                        console.log('Failed to create Accounts: no data');
                    }
                } else {
                    console.log('Failed to create Accounts: server error: ' + res.status + "!");
                }
            })
            .catch(err => {
                console.log('Failed to create Accounts: server error');
                console.log(err);
            })
    }

    async deleteAccounts() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts/admin/delete/';
        const httpAgent = new http.Agent({keepAlive: true});
        const instance = axios.create({
            httpAgent,
        });
        const {t} = this.props;
        const logins: string[] = [];

        for(let x of this.state.selectedAccounts){
            try {
                let res = await axios.delete(url + x.login, {httpAgent});
                if (res.status == 200) {
                    console.log('deleted!');
                    logins.push(x.login);
                } else {
                    console.log('Failed to delete Accounts: server error: ' + res.status + "!");
                }
            } catch (err) {
                console.log('Failed to delete Accounts: server error');
                console.log(err);
            }
        }
        this.setState({
            showInfoDialog: true,
            showDialogMessage: t('Accounts.accountsDeleted') + " " + logins.toString() + '!',
            loadOnClose: true
        });
    }

    loadAccounts() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts';
        axios.get(url)
            .then(res => {
                if (res.status == 200) {
                    if (res.data) {
                        console.log('Loaded ' + res.data.length + ' accounts');
                        this.setState({accounts: res.data});
                    } else {
                        console.log('Failed to get accounts: no data!');
                        this.setState({accounts: []});
                    }
                } else {
                    console.log('Failed to get accounts: server error ' + res.status + '!');
                    this.setState({accounts: []});
                }
            })
            .catch(err => {
                console.log('Failed to get reach articles: server error');
                console.log(err);
                this.setState({accounts: []});
            })
    }

}


const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default compose(
    withRouter,
    withTranslation('common'),
    connect(mapStateToProps)
)(Admin) as any;